import { useFn } from '@eturi/react'
import { useContext, useEffect } from 'react'
import { BackHistoryContext } from './BackHistoryContext.js'

export const useBackHistory = (enabled: boolean, onClose: () => void | false) => {
	const backHistory = useContext(BackHistoryContext)
	const onBack = useFn(onClose)

	useEffect(() => {
		if (!enabled) return

		return backHistory(onBack)
	}, [enabled])
}
